// Copyright (c) 2016 Deere & Company

import {
    createLaborRateHistoryReport,
    resetLaborRateHistoryReport
} from './report';
import {
    resetLaborRateHistoryCriteria,
    updateLaborRateHistoryCriteria
} from './criteria';
import {sharedActionCreators} from '../../shared/action-creators';

export default {
    createLaborRateHistoryReport,
    resetLaborRateHistoryCriteria,
    resetLaborRateHistoryReport,
    updateLaborRateHistoryCriteria,
    ...sharedActionCreators
};



// WEBPACK FOOTER //
// ./src/reports/labor-rate-history/action-creators/index.js